import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.scss']
})
export class RibbonComponent implements OnInit {
  @Input() isOpened: boolean = true;
  @Input() ribbonClass: string | undefined;


  @HostBinding('class.closed') registrationClosed: boolean | undefined

  ngOnInit(): void {
    this.registrationClosed = !this.isOpened;
  }

}
